import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        if (typeof window === 'undefined') return null;
        try {
            const stored = localStorage.getItem('auth-user');
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            console.warn('Failed to parse stored auth user', error);
            return null;
        }
    });

    useEffect(() => {
        if (!user) return;
        try {
            localStorage.setItem('auth-user', JSON.stringify(user));
        } catch (error) {
            console.warn('Failed to persist auth user', error);
        }
    }, [user]);

    const login = (userData) => {
        setUser(userData);
        try {
            localStorage.setItem('auth-user', JSON.stringify(userData));
        } catch (error) {
            console.warn('Failed to persist auth user', error);
        }
    };

    const logout = () => {
        setUser(null);
        try {
            localStorage.removeItem('auth-user');
        } catch (error) {
            console.warn('Failed to clear auth user', error);
        }
        // Here you might also want to call a logout API endpoint
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
